"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.info = exports.initLogger = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
var log = __importStar(require("loglevel"));
function initLogger() {
    if (window.logs === undefined) {
        window.logs = log.noConflict();
    }
}
exports.initLogger = initLogger;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function info(message) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var timestamp = new Date().toLocaleString('nl-NL');
    var logMessage = "[".concat(timestamp, "] - ").concat(message);
    log.info(logMessage);
    if (args.length) {
        for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
            var arg = args_1[_a];
            log.info(arg);
        }
    }
}
exports.info = info;
//# sourceMappingURL=logger.js.map